import { useState, type FormEvent } from 'react';
import { api, mensagemErro } from '../api';
import { useAuth } from '../auth';
import { Erro, Toast, useToast } from '../components/ui';
import { formatarWhatsapp } from '../format';

/** WhatsApp do vendedor nesta empresa: vai no botão "Falar no WhatsApp" dos e-mails (specs/24). */
function SeuWhatsapp() {
  const { me, recarregarMe } = useAuth();
  const toast = useToast();
  const atual = me?.usuario.whatsapp ?? null;
  const [v, setV] = useState(atual ? formatarWhatsapp(atual) : '');
  const [erro, setErro] = useState<string | null>(null);
  const [salvando, setSalvando] = useState(false);
  const salvar = async (e: FormEvent) => {
    e.preventDefault();
    setErro(null);
    setSalvando(true);
    try {
      await api('/me/whatsapp', { method: 'PUT', body: { whatsapp: v.trim() || null } });
      await recarregarMe();
      toast.show(v.trim() ? 'WhatsApp salvo.' : 'WhatsApp removido.');
    } catch (err) {
      setErro(mensagemErro(err));
    } finally {
      setSalvando(false);
    }
  };
  return (
    <form className="card" style={{ maxWidth: 520 }} onSubmit={salvar}>
      <h2>Seu WhatsApp</h2>
      <Erro erro={erro} />
      <label className="field"><span>WhatsApp comercial</span>
        <input className="input num" inputMode="tel" placeholder="(47) 9 0000-0000" value={v} maxLength={30} onChange={(e) => setV(e.target.value)} />
        <span className="hint">
          {atual ? 'Aparece no botão “Falar no WhatsApp” dos e-mails que você envia.' : 'Sem número, seus e-mails saem sem o botão “Falar no WhatsApp”.'}
        </span>
      </label>
      <div><button type="submit" className="btn primary" disabled={salvando}>{salvando ? 'Salvando…' : 'Salvar WhatsApp'}</button></div>
      <Toast msg={toast.msg} onDone={toast.clear} />
    </form>
  );
}

export function ContaPage() {
  const { me } = useAuth();
  const toast = useToast();
  const vazio = { senhaAtual: '', novaSenha: '', confirmar: '' };
  const [f, setF] = useState(vazio);
  const [erro, setErro] = useState<string | null>(null);
  const [salvando, setSalvando] = useState(false);
  const set = (k: keyof typeof f) => (e: { target: { value: string } }) => setF({ ...f, [k]: e.target.value });

  const salvar = async (e: FormEvent) => {
    e.preventDefault();
    setErro(null);
    if (f.novaSenha !== f.confirmar) return setErro('A confirmação não confere com a nova senha.');
    setSalvando(true);
    try {
      await api('/me/senha', { body: { senhaAtual: f.senhaAtual, novaSenha: f.novaSenha } });
      setF(vazio);
      toast.show('Senha alterada. Outros dispositivos foram desconectados.');
    } catch (err) {
      setErro(mensagemErro(err));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <>
      <div className="page-head"><div><h1>Minha conta</h1></div></div>

      <div className="card" style={{ maxWidth: 520 }}>
        <h2>Dados</h2>
        <div className="form-grid">
          <div className="field"><span>Nome</span><strong style={{ fontWeight: 500 }}>{me?.usuario.nome}</strong></div>
          <div className="field"><span>E-mail</span><strong style={{ fontWeight: 500 }}>{me?.usuario.email}</strong></div>
          <div className="field"><span>Empresa</span><strong style={{ fontWeight: 500 }}>{me?.empresa.nome}</strong></div>
          <div className="field"><span>Perfil</span><strong style={{ fontWeight: 500 }}>{me?.perfil === 'ADMIN' ? 'Administrador' : 'Vendedor'}</strong></div>
        </div>
      </div>

      <SeuWhatsapp />

      <form className="card" style={{ maxWidth: 520 }} onSubmit={salvar}>
        <h2>Trocar senha</h2>
        <Erro erro={erro} />
        <label className="field"><span>Senha atual *</span><input className="input" type="password" required value={f.senhaAtual} onChange={set('senhaAtual')} autoComplete="current-password" /></label>
        <label className="field"><span>Nova senha *</span><input className="input" type="password" required minLength={10} value={f.novaSenha} onChange={set('novaSenha')} autoComplete="new-password" /><span className="hint">Mínimo de 10 caracteres.</span></label>
        <label className="field"><span>Confirmar nova senha *</span><input className="input" type="password" required value={f.confirmar} onChange={set('confirmar')} autoComplete="new-password" /></label>
        <div><button type="submit" className="btn primary" disabled={salvando}>{salvando ? 'Salvando…' : 'Alterar senha'}</button></div>
      </form>
      <Toast msg={toast.msg} onDone={toast.clear} />
    </>
  );
}
